module.exports = __webpack_public_path__ + "img/X9.fd1b8af7.png";